import { Injectable, ComponentFactory, ComponentFactoryResolver, Type } from '@angular/core';
import { BlocksContentPreformatter } from '../interface';

// NOTE: 'any' used instead of 'root' because it fixes a bug
// when you want to replace one of providers for block in lazy-module.
// Somehow this block assigned wrong (root) injector in this case.
@Injectable({ providedIn: 'any' })
export class BuildContentService {
  private contentComponentsFactories = new Map<string, ComponentFactory<unknown>>();
  private processedComponents = new Map<Type<unknown>, boolean>();
  private contentPreformatters = new Set<BlocksContentPreformatter>();

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  hasContentComponentFactory(tagName: string): boolean {
    return this.contentComponentsFactories.has(tagName);
  }

  getContentComponentFactory(tagName: string): ComponentFactory<unknown> | undefined {
    return this.contentComponentsFactories.get(tagName);
  }

  storeContentComponentsFactories(contentComponents: Type<unknown>[][] = []): void {
    for (const componentsGroup of contentComponents || []) {
      for (const component of componentsGroup) {
        if (this.processedComponents.has(component)) {
          continue;
        }

        const factory = this.componentFactoryResolver.resolveComponentFactory(component);
        const selectors = this.getFactorySelectors(factory);
        for (const selector of selectors) {
          this.contentComponentsFactories.set(selector, factory);
        }

        this.processedComponents.set(component, true);
      }
    }
  }

  preformatContent(content: string | undefined): string | undefined {
    if (!content) {
      return content;
    }

    return Array.from(this.contentPreformatters).reduce((content, preformatter) => preformatter(content), content);
  }

  storeContentPreformatters(contentPreformatters: BlocksContentPreformatter[][] | null | undefined): void {
    contentPreformatters?.forEach(blockPreformatters =>
      blockPreformatters.forEach(preformatter => this.contentPreformatters.add(preformatter)),
    );
  }

  private getFactorySelectors(factory: ComponentFactory<unknown>): string[] {
    return factory.selector
      .split(',')
      .map(selector => selector.trim().toUpperCase())
      .filter(selector => selector.length > 0);
  }
}
